/* eslint-disable react/prop-types */
import Certificate from 'Assets/images/pages/web-chat/certificate.svg';
import ConsultImage from 'Assets/images/pages/web-chat/consultation-history.svg';
import Files from 'Assets/images/pages/web-chat/files.svg';
import MemoImage from 'Assets/images/pages/web-chat/memo_icon.svg';
import Money from 'Assets/images/pages/web-chat/money.svg';
import PatientImage from 'Assets/images/pages/web-chat/patient-details.svg';
import Prescription from 'Assets/images/pages/web-chat/pill.svg';
import ReferralMemoImage from 'Assets/images/pages/web-chat/referral-memo.svg';
import { bool, func } from 'prop-types';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { MALAYSIA_ISO_CODE } from 'Constants/commons';

import OptionItem from './OptionItem';

const ListMenu = props => {
  const {
    openPOS,
    goToPatient,
    goToAllMedia,
    isGoingConsult,
    openMemoRandum,
    goToConsultHistory,
    openPrescriptionModal,
    openReferralMemo,
    openMedicalCertificate,
    pendingConsultActive,
  } = props;

  const doctor = useSelector(state => state.doctors.profile, shallowEqual);
  const practiseCountryCode = doctor?.practiseCountry?.iso;

  // Hide if doctor practise country is Malaysia
  const hideIssueMcFeature = practiseCountryCode === MALAYSIA_ISO_CODE;

  const issueMedicalCertificate = () => {
    openMedicalCertificate(null);
  };

  return (
    <div className="options">
      {isGoingConsult && pendingConsultActive === -1 && (
        <>
          {!hideIssueMcFeature && (
            <OptionItem
              icon={Certificate}
              content="Create Medical Certificate"
              onClickItem={issueMedicalCertificate}
            />
          )}
          <OptionItem icon={MemoImage} onClickItem={openMemoRandum} content="Create Memo" />
          <OptionItem
            onClickItem={openReferralMemo}
            icon={ReferralMemoImage}
            content="Create Referral Letter"
          />
          <OptionItem
            onClickItem={openPrescriptionModal}
            icon={Prescription}
            content="Issue Prescription"
          />
          <OptionItem icon={Money} onClickItem={openPOS} content="Point of Sale" />
        </>
      )}
      <OptionItem icon={PatientImage} content="Patient Info" onClickItem={goToPatient} />
      {pendingConsultActive === -1 && (
        <>
          <OptionItem icon={Files} content="Attached Files" onClickItem={goToAllMedia} />
          <OptionItem
            icon={ConsultImage}
            content="Consult History"
            onClickItem={goToConsultHistory}
          />
        </>
      )}
    </div>
  );
};

ListMenu.propTypes = {
  openPOS: func.isRequired,
  goToPatient: func.isRequired,
  goToAllMedia: func.isRequired,
  isGoingConsult: bool.isRequired,
  openMemoRandum: func.isRequired,
  goToConsultHistory: func.isRequired,
  openPrescriptionModal: func.isRequired,
  openReferralMemo: func.isRequired,
  openMedicalCertificate: func.isRequired,
};

ListMenu.defaultProps = {};

export default ListMenu;
